import $ from 'jquery'
import _ from 'underscore'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-accessibility')
    .each(function(i, el) {
      new ResizeText(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

class ResizeText {
  constructor(el) {
    const self = this
    self.$el = $(el)

    self.$el.on('click', '.js-resize-text', e => {
      this.resizeText(el, $(e.currentTarget).attr('data-zoom'))
    })
  }
  resizeText(el, multiplier) {
    var newSize = $(el)
      .closest('.c-scuba-layout__section')
      .first()
      .css('font-size')
    $(el)
      .closest('.c-scuba-layout__section')
      .first()
      .css('font-size', parseInt(newSize) * multiplier)
    $(el)
      .closest('.c-scuba-layout__section')
      .first()
      .css('line-height', '1.1em')
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ResizeText.js